<div class="main-content table-page tablero-bsc">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>{{ titulo }}</h1>
        <p>{{ resumen }}</p>
      </div>
      <div class="table-page__toolbar-actions tablero-bsc__acciones">
        <a mat-button routerLink="/admin/bsc/indicadores" [queryParams]="{ anio: anio, corte: corte }">Indicadores generales</a>
        <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
           *ngIf="puedeCargarExcel" [routerLink]="ruta.cargaExcel">
          <span class="material-icons" aria-hidden="true">upload_file</span>
          Cargar Excel
        </a>
        <!-- El consolidado del año al corte elegido (exportarConsolidado.do, F4.4). -->
        <button mat-raised-button type="button" class="btn table-page__icon-btn table-page__icon-btn--secondary"
                *ngIf="puedeExportar" [disabled]="exportando || loading" [attr.aria-busy]="exportando"
                (click)="exportar()">
          <span class="material-icons" aria-hidden="true">{{ exportando ? "hourglass_top" : "download" }}</span>
          {{ exportando ? "Exportando…" : "Exportar FOR-011" }}
        </button>
        <a mat-raised-button class="btn table-page__primary-btn" *ngIf="puedeComparar" [routerLink]="ruta.comparativo"
           [queryParams]="queryComparativo">
          <span class="material-icons" aria-hidden="true">compare_arrows</span>
          Comparar años
        </a>
      </div>
    </section>

    <div class="bsc-franja tablero-bsc__exportar" role="alert" *ngIf="errorExportar">
      <span class="material-icons" aria-hidden="true">error_outline</span>
      <span>{{ errorExportar }}</span>
    </div>

    <app-selector-corte-bsc prefijo="bsc-tablero" [anio]="anioInicial" [corte]="corteInicial"
                            [deshabilitado]="loading" (cambio)="onSeleccion($event)">
      <!-- Siempre presente: si se quita al consultar, el combo de corte brinca a la derecha. -->
      <div meta class="tickets-toolbar__meta" *ngIf="corte">
        <span>{{ loading ? "Consultando…" : textoCiclo }}</span>
        <strong>{{ textoCorteMeta }}</strong>
      </div>
    </app-selector-corte-bsc>

    <section class="table-page__card" *ngIf="loading">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">hourglass_top</span>
        <h3>Consultando el tablero</h3>
        <p>Espere un momento.</p>
      </div>
    </section>

    <section class="table-page__card" *ngIf="!loading && error">
      <div class="table-page__empty">
        <span class="material-icons" aria-hidden="true">lock_outline</span>
        <h3>No se pudo consultar el tablero</h3>
        <p>{{ error }}</p>
      </div>
    </section>

    <ng-container *ngIf="!loading && !error && dashboard">
      <!-- Un bloque que no se pudo leer o calcular. Con un estado vacío los avisos
           van dentro de su tarjeta: ahí son la explicación. -->
      <output class="bsc-franja tablero-bsc__avisos"
              *ngIf="avisos.length > 0 && (estado === 'DATOS' || estado === 'SIN_PLANEACIONES')">
        <span class="material-icons" aria-hidden="true">info</span>
        <ul>
          <li *ngFor="let aviso of avisos">{{ aviso }}</li>
        </ul>
      </output>

      <!-- ============================ Estados vacíos ============================ -->
      <section class="table-page__card tablero-bsc__vacio" *ngIf="estado !== 'DATOS'" aria-labelledby="tablero-bsc-vacio">
        <div class="table-page__empty">
          <ng-container [ngSwitch]="estado">
            <ng-container *ngSwitchCase="'SIN_LECTURA'">
              <span class="material-icons" aria-hidden="true">sync_problem</span>
              <h3 id="tablero-bsc-vacio">No se pudo leer el BSC de {{ anio }}</h3>
              <p>
                Una parte del año no se pudo consultar, así que no se sabe qué áreas tienen planeación. Los datos no se
                perdieron: vuelve a consultar en un momento.
              </p>
            </ng-container>
            <ng-container *ngSwitchCase="'SIN_CICLO'">
              <span class="material-icons" aria-hidden="true">event_busy</span>
              <h3 [id]="'tablero-bsc-vacio'">{{ anio }} no tiene datos en el BSC</h3>
              <p>
                El año se da de alta en Parámetros (con sus fechas y umbrales) o al cargar el FOR-011 de un año anterior en
                modo histórico.
              </p>
            </ng-container>
            <ng-container *ngSwitchCase="'SIN_PLANEACIONES'">
              <span class="material-icons" aria-hidden="true">assignment_late</span>
              <h3 [id]="'tablero-bsc-vacio'">Ninguna área tiene planeación autorizada en {{ anio }}</h3>
              <p>
                El tablero solo suma planeaciones autorizadas: sus metas quedan fijas y sobre ellas se mide el avance. Carga
                el FOR-011 de un área o envía su planeación a autorización. Abajo, en qué va cada área.
              </p>
            </ng-container>
            <ng-container *ngSwitchCase="'SIN_CORTE'">
              <span class="material-icons" aria-hidden="true">date_range</span>
              <h3 [id]="'tablero-bsc-vacio'">El corte anual de {{ anio }} todavía no tiene datos</h3>
              <p>El corte anual es el último trimestre autorizado. Elige Q1, Q2, Q3 o Q4 para ver el avance en vivo.</p>
            </ng-container>
          </ng-container>

          <ul class="tablero-bsc__vacio-avisos" *ngIf="avisos.length > 0 && estado !== 'SIN_PLANEACIONES'">
            <li *ngFor="let aviso of avisos">{{ aviso }}</li>
          </ul>

          <div class="tablero-bsc__vacio-acciones" *ngIf="estado === 'SIN_LECTURA'">
            <button mat-raised-button type="button" class="btn table-page__primary-btn" (click)="consultar()">
              <span class="material-icons" aria-hidden="true">refresh</span>
              Volver a consultar
            </button>
          </div>
          <!-- Dar de alta, planear o cargar solo cuando se sabe que falta (no si no se pudo leer). -->
          <div class="tablero-bsc__vacio-acciones" *ngIf="estado === 'SIN_CICLO' || estado === 'SIN_PLANEACIONES'">
            <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
               *ngIf="estado === 'SIN_CICLO' && puedeConfigurar" [routerLink]="ruta.parametros">
              <span class="material-icons" aria-hidden="true">tune</span>
              Configurar {{ anio }}
            </a>
            <a mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary"
               *ngIf="estado === 'SIN_PLANEACIONES' && puedePlanear" [routerLink]="ruta.planeacion"
               [queryParams]="queryPlaneacion">
              <span class="material-icons" aria-hidden="true">event_note</span>
              Planeación de metas
            </a>
            <a mat-raised-button class="btn table-page__primary-btn" *ngIf="puedeCargarExcel" [routerLink]="ruta.cargaExcel">
              <span class="material-icons" aria-hidden="true">upload_file</span>
              Cargar Excel FOR-011
            </a>
          </div>
        </div>
      </section>

      <!-- ============================ Tiles y gráficas ============================ -->
      <div class="tickets-dashboard tablero-bsc__cuerpo" *ngIf="estado === 'DATOS'">
        <app-tiles-bsc [tiles]="tiles" etiqueta="Indicadores generales"></app-tiles-bsc>

        <section aria-labelledby="tablero-bsc-for011">
          <header class="bsc-bloque__encabezado">
            <h2 id="tablero-bsc-for011">Gráficas del FOR-011</h2>
            <p>Elige las gráficas que quieres mostrar.</p>
            <fieldset class="tablero-bsc__chips">
              <legend class="cdk-visually-hidden">Visibilidad de las gráficas</legend>
              <button *ngFor="let grafica of graficas" type="button"
                      class="app-form-btn app-form-btn--secondary app-form-btn--compact tablero-bsc__chip"
                      [attr.aria-pressed]="grafica.visible" (click)="alternarGrafica(grafica)">
                <span class="material-icons" aria-hidden="true">{{ grafica.visible ? "check" : "add" }}</span>
                {{ grafica.etiqueta }}
              </button>
            </fieldset>
          </header>
          <div class="tablero-bsc__graficas">
          <article *ngIf="visible('cumplimiento')" class="tickets-card tablero-bsc__grafica tablero-bsc__grafica--trimestres">
            <div class="tickets-card__header"><div>
              <span>{{ textoCorte }}</span>
              <h2>Cumplimiento por área y trimestre</h2>
            </div></div>
            <app-cumplimiento-area-q-bsc *ngIf="areasTrimestrales.length > 0; else sinTrimestres"
              [areas]="areasTrimestrales" [objetivo]="dashboard.objetivoSolser ?? null"></app-cumplimiento-area-q-bsc>
            <ng-template #sinTrimestres><p class="tickets-empty">No hay alcances trimestrales por área.</p></ng-template>
            <p class="tablero-bsc__nota-grafica">Alcance acumulado de cada trimestre hasta el corte seleccionado; los trimestres sin dato no se pintan.</p>
          </article>
          <article *ngIf="visible('anual')" class="tickets-card tablero-bsc__grafica">
            <div class="tickets-card__header"><div>
              <span>{{ anio }}</span>
              <h2>Promedio anual por área</h2>
            </div></div>
            <app-promedio-anual-area-bsc *ngIf="barrasAnuales.length > 0" [barras]="barrasAnuales"></app-promedio-anual-area-bsc>
            <p class="tablero-bsc__nota-grafica" aria-live="polite">{{ notaAnual }}</p>
          </article>
          <article *ngIf="visible('areas')" class="tickets-card tablero-bsc__grafica tablero-bsc__grafica--areas">
            <div class="tickets-card__header">
              <div>
                <span>{{ textoCorte }}</span>
                <h2>Alcance acumulado por área</h2>
              </div>
            </div>
            <app-barras-area-bsc *ngIf="barras.length > 0; else sinBarras" [barras]="barras"
                                 [objetivo]="dashboard.objetivoSolser ?? null"
                                 [descripcion]="'Alcance acumulado por área ' + textoCorte"></app-barras-area-bsc>
            <ng-template #sinBarras>
              <p class="tickets-empty">Ninguna área tiene alcance {{ textoCorte }}.</p>
            </ng-template>
            <p class="tablero-bsc__nota-grafica">
              Promedio de los KPI vigentes de cada área, como la hoja «Indicadores por Area»; los KPI que inician después
              no cuentan hasta que aplican.
              <ng-container *ngIf="areasSinBarra > 0">
                {{ areasSinBarra === 1 ? "Un área sin alcance al corte no aparece." : areasSinBarra + " áreas sin alcance al corte no aparecen." }}
              </ng-container>
            </p>
          </article>

          <article *ngIf="visible('gerencial')" class="tickets-card tablero-bsc__grafica">
            <div class="tickets-card__header">
              <div>
                <span>{{ textoCorte }}</span>
                <h2>Estatus gerencial</h2>
              </div>
            </div>
            <app-pastel-gerencial-bsc [alcanzado]="dashboard.pastelAlcanzado ?? null"
                                      [noCumplido]="dashboard.pastelNoCumplido ?? null"
                                      [porCumplir]="dashboard.pastelPorCumplir ?? null"
                                      [objetivo]="dashboard.objetivoSolser ?? null"></app-pastel-gerencial-bsc>
            <p class="tablero-bsc__nota-grafica">
              Como el pastel «ESTATUS GERENCIAL» del FOR-011: lo alcanzado, lo programado al corte que no se cumplió y lo
              que resta del año.
            </p>
          </article>

          <article *ngIf="visible('trimestres')" class="tickets-card tablero-bsc__grafica">
            <div class="tickets-card__header">
              <div>
                <span>{{ anio }}</span>
                <h2>Alcance trimestral total</h2>
              </div>
            </div>
            <app-acumulado-q-bsc [real]="dashboard.serieRealQ" [programado]="dashboard.serieProgramadoQ"
                                 [objetivo]="dashboard.serieObjetivoQ"
                                 [descripcion]="'Alcance acumulado de la empresa por trimestre en ' + anio"></app-acumulado-q-bsc>
            <p class="tablero-bsc__nota-grafica">
              {{ q != null && q < 4 ? "Después del corte solo se ve lo programado." : "Real y programado acumulados de la empresa." }}
            </p>
          </article>
          </div>
        </section>
      </div>

      <!-- ============================ Áreas ============================ -->
      <section class="table-page__card bsc-bloque tablero-bsc__areas"
               *ngIf="estado !== 'SIN_CICLO' && estado !== 'SIN_LECTURA'"
               aria-labelledby="tablero-bsc-areas">
        <header class="bsc-bloque__encabezado">
          <h2 id="tablero-bsc-areas">Áreas</h2>
          <p>
            Snapshot de los trimestres autorizados y en vivo los demás. La entrega es la del trimestre del corte; una
            fecha límite vacía nunca vence.
          </p>
        </header>

        <div class="table-page__table-wrap" *ngIf="filas.length > 0; else sinAreas">
          <table class="table-page__table tablero-bsc__tabla">
            <thead>
              <tr>
                <th scope="col" class="tablero-bsc__col-area">Área</th>
                <th scope="col" class="tablero-bsc__num">KPIs</th>
                <th scope="col" class="tablero-bsc__num" *ngFor="let c of columnasQ">Q{{ c }}</th>
                <th scope="col" class="tablero-bsc__num">{{ q != null ? "Alcance Q" + q : "Alcance" }}</th>
                <th scope="col" class="tablero-bsc__num">Programado</th>
                <th scope="col">Semáforo</th>
                <th scope="col">{{ q != null ? "Entrega Q" + q : "Entrega" }}</th>
                <th scope="col">Envío</th>
                <th scope="col">Fecha límite</th>
                <th scope="col" class="table-page__actions-head"><span class="bsc-oculto">Acciones</span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let f of filas; trackBy: trackFila">
                <td class="tablero-bsc__col-area">
                  <div class="table-page__cell-stack">
                    <strong class="table-page__name">{{ f.area }}</strong>
                    <span class="table-page__subtext" *ngIf="f.nota">{{ f.nota }}</span>
                  </div>
                </td>
                <td class="tablero-bsc__num">
                  <div class="table-page__cell-stack">
                    <span class="table-page__text">{{ f.kpis }}</span>
                    <span class="table-page__subtext tablero-bsc__sin-captura" *ngIf="f.kpisNota">{{ f.kpisNota }}</span>
                  </div>
                </td>
                <td class="tablero-bsc__num" *ngFor="let a of f.alcancesQ">{{ a }}</td>
                <td class="tablero-bsc__num"><strong class="tablero-bsc__alcance">{{ f.alcance }}</strong></td>
                <td class="tablero-bsc__num tablero-bsc__programado">{{ f.programado }}</td>
                <td>
                  <span class="table-page__status-badge" *ngIf="f.semaforo; else sinSemaforo" [ngClass]="f.semaforo.clase">
                    <span class="material-icons" aria-hidden="true">{{ f.semaforo.icono }}</span>
                    {{ f.semaforo.texto }}
                  </span>
                  <ng-template #sinSemaforo><span class="table-page__subtext">—</span></ng-template>
                </td>
                <td>
                  <div class="table-page__cell-stack">
                    <span class="table-page__status-badge" *ngIf="f.entrega; else sinEntrega" [ngClass]="f.entrega.clase">
                      <span class="material-icons" aria-hidden="true">{{ f.entrega.icono }}</span>
                      {{ f.entrega.texto }}
                    </span>
                    <ng-template #sinEntrega><span class="table-page__subtext">—</span></ng-template>
                    <span class="table-page__subtext" *ngIf="f.entregaNota">{{ f.entregaNota }}</span>
                  </div>
                </td>
                <td class="tablero-bsc__fecha">{{ f.envio }}</td>
                <td class="tablero-bsc__fecha">{{ f.limite }}</td>
                <td>
                  <div class="tablero-bsc__acciones-fila">
                    <a class="table-page__link" *ngIf="f.idBscArea != null" [routerLink]="[ruta.area, f.idBscArea]"
                       [queryParams]="{ anio: anio, corte: corte }" [attr.aria-label]="f.etiquetaVer">Ver área</a>
                    <a class="table-page__link" *ngIf="f.cargar" [routerLink]="ruta.cargaExcel">Cargar Excel</a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <ng-template #sinAreas>
          <div class="table-page__empty">
            <span class="material-icons" aria-hidden="true">groups</span>
            <h3>No hay áreas participantes</h3>
            <p>Las áreas del BSC se dan de alta en Parámetros.</p>
          </div>
        </ng-template>
      </section>
    </ng-container>
  </div>
</div>
